import React from "react";
import { Link } from "react-router-dom";
import { useAppInfo } from "../../../helpers/hooks/common-hook";
import WebScriptSnippet from "./web-script-snippt";

const steps = [
  ["Copy the snippet", "It loads the BotCircuits widget and starts it for this app."],
  ["Paste it into your website", "Add it just before the closing </body> tag on every page where visitors should see the assistant."],
  ["Add an access key", "Create or manage access keys", "/access-keys"],
  ["Publish your agent", "Open Versions to publish your agent", "/versions"],
];

const toggleExample = `// Open or close the widget from your own buttons
botcircuits_toggle(true);

// Get notified when visitors open or close it
botcircuits_init('<APP_ID>', '<ACCESS_KEY>', {}, {
  onToggleState: isOpen => console.log('widget open:', isOpen),
});`;

export default function WebChatInstall() {
  const { appId } = useAppInfo();
  return (
    <div className="mx-auto w-full max-w-4xl px-4 py-6 sm:px-6 lg:px-8">
      <header className="mb-6">
        <h1 className="text-2xl font-semibold tracking-tight text-gray-900">Install on your website</h1>
        <p className="mt-2 text-sm text-gray-500">
          Add your assistant with a short code snippet. The widget uses the appearance saved on the Settings tab.
        </p>
      </header>

      <section className="rounded-2xl border border-gray-200 bg-white p-5 sm:p-6">
        <h2 className="text-sm font-semibold text-gray-900">Embed code</h2>
        <div className="mt-3"><WebScriptSnippet /></div>
      </section>

      <section className="mt-5 rounded-2xl border border-gray-200 bg-white p-5 sm:p-6">
        <h2 className="text-sm font-semibold text-gray-900">Setup steps</h2>
        <ol className="mt-4 space-y-4">
          {steps.map(([title, detail, href], index) => (
            <li key={title} className="flex gap-3">
              <span aria-hidden="true" className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-gray-900 text-xs font-semibold text-white">{index + 1}</span>
              <div>
                <p className="text-sm font-medium text-gray-800">{title}</p>
                <p className="mt-0.5 text-xs leading-5 text-gray-500">{href ? (
                  <Link to={`/app/${appId}${href}`} target="_blank" rel="noopener noreferrer" className="font-medium text-blue-600 underline hover:text-blue-700 dark:text-blue-400">
                    {detail} <span className="sr-only">(opens in a new tab)</span>
                  </Link>
                ) : detail}</p>
              </div>
            </li>
          ))}
        </ol>
      </section>

      <section className="mt-5 rounded-2xl border border-gray-200 bg-white p-5 sm:p-6">
        <h2 className="text-sm font-semibold text-gray-900">Optional: control the widget from your page</h2>
        <pre className="mt-3 overflow-x-auto rounded-xl bg-gray-900 p-4 text-xs leading-5 text-gray-100"><code>{toggleExample}</code></pre>
      </section>
    </div>
  );
}
